let isLoading = false; // spam istekleri engellemek için

const loadItems = (button) => {
  if (isLoading) return; // aynı anda tekrar çağrılmasını engelle
  isLoading = true;

  const totalPages = parseInt($('[data-total-pages]').val());
  let currentPage = parseInt($('[data-current-page]').val());

  const nextUrl = $('[data-next-url]').val();
  if (!nextUrl) {
    console.warn('nextUrl boş, istek yapılmıyor');
    isLoading = false;
    return;
  }

  button.setAttribute("disabled", "");
  button.classList.add('loading');

  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    success: function(responseHTML) {
      const $response = $(responseHTML);

      // Yeni ürünleri ekle
      const newItems = $response.find('.load-more-grid').html();
      $('.load-more-grid').append(newItems);

      // 🔁 Yeni nextUrl ve currentPage'i HTML'den al
      const newNextUrl = $response.find('[data-next-url]').val();
      const newCurrentPage = $response.find('[data-current-page]').val();

      // 💡 Güncelleme: Eğer yeni değerler varsa DOM’a yaz
      if (newNextUrl && newCurrentPage) {
        $('[data-next-url]').val(newNextUrl).attr('data-next-url', newNextUrl);
        $('[data-current-page]').val(newCurrentPage).attr('data-current-page', newCurrentPage);
        currentPage = parseInt(newCurrentPage);
      } else {
        console.warn("Yeni nextUrl bulunamadı. Scroll durdurulacak.");
        button.remove(); // artık yeni sayfa yoksa butonu kaldır
        return;
      }

      // Renk seçenekleri varsa uygula
      if (typeof colorSwatches === 'function') {
        colorSwatches();
      }
    },
    complete: function() {
      isLoading = false;

      if (currentPage >= totalPages) {
        button.remove(); // son sayfadaysa butonu kaldır
      } else {
        button.removeAttribute("disabled");
        button.classList.remove('loading');

        if (typeof checkVisibility === 'function') {
          checkVisibility(); // infinite scroll tetikleyici varsa çağır
        }
      }
    },
    error: function() {
      console.error("Ürünler yüklenirken hata oluştu.");
      isLoading = false;
      button.removeAttribute("disabled");
      button.classList.remove('loading');
    }
  });
}



const checkVisibility = () => {
  const spinnerList = document.querySelectorAll('.js-infinite-scroll');
  spinnerList.forEach(spinner => {
    const sectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            loadItems(spinner);
          }
        })
      }
    );

    sectionObserver.observe(spinner);
  })
}

function loadMore() {  
  document.querySelectorAll('.js-load-more').forEach((button) => {
    button.onclick = () => {
      loadItems(button);
    }
  });

  checkVisibility();
}

(function () {
  loadMore();
})();